/**
 * String utility functions
 *
 * This file contains string manipulation utilities for:
 * - Value retrieval with fallbacks
 * - Search string normalization
 * - Type-safe string conversion
 */

export const getValueOrFallback = (value?: string | null, fallback = ''): string => {
  return value?.trim() ? value : fallback;
};

type NormalizeSearchValueOptions = {
  minLength?: number;
};

const toSearchString = (searchValue: unknown): string => {
  if (searchValue == null) {
    return '';
  }
  if (typeof searchValue === 'string') {
    return searchValue;
  }
  if (typeof searchValue === 'number' || typeof searchValue === 'boolean' || typeof searchValue === 'bigint') {
    return String(searchValue);
  }
  return '';
};

export const normalizeSearchValue = (
  searchValue: unknown,
  { minLength }: NormalizeSearchValueOptions = {}
): string | undefined => {
  const trimmedSearchValue = toSearchString(searchValue).trim();

  if (!trimmedSearchValue) {
    return undefined;
  }

  if (minLength !== undefined && trimmedSearchValue.length <= minLength) {
    return undefined;
  }

  return trimmedSearchValue;
};
